import styled from '@emotion/styled'
import { Box } from '@mui/system'
import TwitterIcon from 'assets/icons-gray/twitter.svg'
import TelegramIcon from 'assets/icons-gray/telegram.svg'
import MediumIcon from 'assets/icons-gray/medium.svg'
import { HelloNextURL } from 'constants/externalLink'
import { Link, Typography } from '@mui/material'
import BlockStatus from './BlockStatus'
import ArrowUp from 'assets/icons-gray/arrow-diagonal-up.svg'
import CoreContainer from 'core/CoreContainer'
import { useResponsive } from 'hooks/useResponsive'

const FooterContainer = styled(CoreContainer)<{ column: number }>`
  min-height: 100px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 25px;
  flex-direction: ${({ column }) => (column ? 'column' : 'row')};
  border-top: 1px solid rgba(18, 18, 18, 0.12);
  margin-top: -100px;
  position: relative;
  padding: 30px;
`
const BoxCenter = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  margin: 0 auto;
  z-index: 50;
`

const BoxSpaceBTW = styled(CoreContainer)`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 25px;
  z-index: 10;
`

const CustomItem = styled(Link)`
  width: 42px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer !important;
  :hover {
    background-color: #1212121f;
    border-radius: 100%;
    width: 42px;
    height: 42px;
  }
`
const Footer = () => {
  const { isTablet } = useResponsive()
  return (
    <FooterContainer column={isTablet ? 1 : 0}>
      <BoxCenter
        sx={{
          position: isTablet ? 'relative' : 'absolute',
        }}
      >
        <CustomItem href="https://twitter.com/EdgeProtocol" target="_blank">
          <img src={TwitterIcon} alt="TwitterIcon" width={24} height={24} />
        </CustomItem>
        <CustomItem href="https://t.me/edgeprotocol" target="_blank">
          <img src={TelegramIcon} alt="TelegramIcon" width={24} height={24} />
        </CustomItem>
        <CustomItem href="https://medium.com/@edgeprotocol" target="_blank">
          <img src={MediumIcon} alt="MediumIcon" width={24} height={24} />
        </CustomItem>
      </BoxCenter>
      <BoxSpaceBTW
        sx={{
          position: isTablet ? 'relative' : 'absolute',
          justifyContent: isTablet ? 'space-around' : 'space-between',
        }}
      >
        <BlockStatus />
        <Box
          sx={{ display: 'flex', cursor: 'pointer' }}
          onClick={() => window.open(HelloNextURL, '_blank')}
        >
          <Typography
            variant="body2"
            sx={{
              ':hover': {
                textDecoration: 'underline',
              },
            }}
          >
            Give feedback
          </Typography>
          <img src={ArrowUp} alt="ArrowUp" width={16} height={16} />
        </Box>
      </BoxSpaceBTW>
    </FooterContainer>
  )
}

export default Footer
